import { ROUTES, TITLES, PROD, DEV, STAGE } from 'consts';

export const DOCUMENTS_MENU = {
  key: ROUTES.DOCUMENTS.ROOT,
  label: TITLES[ROUTES.DOCUMENTS.ROOT],
  environment: [DEV, STAGE, PROD],
};
